import type { DataSchema, GetViewFormItemsRes, GetViewSettingsRes, Schema } from '../../types';
import type { Row } from '@tanstack/react-table';
import { getFormItemByIdMap } from './getFormItemByIdMap.ts';
import type { ViewItemFile } from '../../types/catalogViewItem.ts';
import { getViewWidgetGrid } from './widgetGrid.ts';

interface GetCatalogueImagesProps<T extends keyof P, P extends DataSchema> {
  rows: Row<Schema<T, P>>[];
  viewWidget?: GetViewSettingsRes;
  usableItems?: GetViewFormItemsRes;
}

export const getCatalogueImages = <T extends keyof P, P extends DataSchema>({ usableItems, viewWidget, rows }: GetCatalogueImagesProps<T, P>) => {
  const formItemById = getFormItemByIdMap(usableItems);

  return rows.flatMap((row) => {
    return [...(viewWidget?.items ?? [])]
      .sort((a, b) => a.order - b.order)
      .map((widgetItem, index): Partial<ViewItemFile> | undefined => {
        const { id, order } = widgetItem;
        const meta = formItemById.get(id);
        const rawValue = row.original[id as keyof Schema<T, P>];

        if (!meta) return;

        if (meta.formItemType === 'FileUpload') {
          return {
            id: meta.formItemId,
            order,
            ...getViewWidgetGrid(widgetItem, { row: index + 1, column: 1 }),
            key: meta.formItemId,
            name: meta.formItemName,
            title: meta?.formItemTitle,
            fileId: ((rawValue as string[]) ?? [])[0],
          };
        }
      })
      .filter((item) => item !== undefined);
  });
};
